import React, { Component } from 'react'

export class Response extends Component {
    renderSpinner() {
        if(this.props.loading) {
            return <div className="loader"></div>
        }
        else {
            return (
                <pre style={{ overflowY: 'auto', height: 'auto', width: '100%', maxHeight: '40vh', lineHeight: '1.5' }}>
                    {this.props.output}
                </pre>
            );
        }
    }

    render() {
        return (
            <div style={{ paddingLeft: '2vw', paddingRight: '1vw' }}>
                <h3 style={{marginBottom: '0', marginTop: '15px'}}>{this.props.title}</h3>
                <div style={{ width: '100%', height: 'auto', maxHeight: '40vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start'}}>
                    {this.renderSpinner()}
                </div>
            </div>
        )
    }
}

export default Response
